import { z } from "zod";
import { CollectNodeFieldTypeEnum } from "../../../../enum/nodes.enum";

export const collectNodeEmailFieldSchema = z.object({
  type: z.literal(CollectNodeFieldTypeEnum.EMAIL),
});
